import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import PasswordChecklist from "react-password-checklist";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import CompanyInsert from "./CompanyInsert";
import { jwtDecode } from "jwt-decode";
import { NavLink, useNavigate } from "react-router-dom";
// import CompanyPost from "./CompanyPost";
const Admin = () => {
  const [user_details, setUserDetails] = useState();
  const [jwtToken] = useState(localStorage.getItem("jwt") || "");
  const { cvCategory, companyList } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(false);
  const navigate = useNavigate()
  const [value, setValue] = useState({
    firstName: user_details && user_details.firstName,
    lastName: "",
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [activeVacancies, setActiveVacancies] = useState(false);
  const [activeJob, setActiveJob] = useState(false);

  useEffect(() => {
    axios
      .get("https://www.turanozbahceci.com/api/profile.php", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setUserDetails(res.data.user);
        setValue((prevState) => ({
          ...prevState,
          firstName: res.data.user.firstName,
          lastName: res.data.user.lastName,
          email: res.data.user.email,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "confirmPassword" || name === "newPassword") {
      if (value.newPassword === value.confirmPassword) {
        setIsPasswordConfirmed(true); // Set to true if passwords match
      } else {
        setIsPasswordConfirmed(false); // Set to false if passwords don't match
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        "https://www.turanozbahceci.com/api/profile.php",
        {
          firstName: value.firstName,
          lastName: value.lastName,
          email: value.email,
          oldPassword: value.oldPassword,
          newPassword: value.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const decodeJwt = jwtDecode(jwtToken);
  const findActiveVacancies =
    companyList &&
    companyList.filter((item) => item.company_id == decodeJwt.data.userId);
  const handleLogout = () => {
    // JWT-ni silirik
    localStorage.removeItem("jwt");
    window.dispatchEvent(new Event("storage"));

    // Yenilənmiş məlumatların tətbiq olunması üçün səhifəni yeniləyirik
    setTimeout(() => {
      window.location.reload(); // səhifəni yeniləyirik
      navigate("/"); // Yenidən yönləndirmə
    }, 100); // 100ms gecikmə ilə
  };
  return (
    <>
      <div className="my-account-section section section-padding-bottom">
        <div className="section-title">
          <h2 className="title text-center my-5 fz-48">
            {t.welcome} <span>{t.welcome1}</span>
          </h2>
        </div>
        {user_details && user_details.subscription == "2" ? (
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {/* My Account Tab Menu Start */}
                  <div className="col-lg-3 col-12">
                    <div className="myaccount-tab-menu nav" role="tablist">
                      <a
                        href="#dashboad"
                        className="active"
                        data-bs-toggle="tab"
                      >
                        <i className="fas fa-tachometer-alt-slow" />
                        {user_details.firstName} {user_details.lastName}
                      </a>
                      <a href="#orders" data-bs-toggle="tab">
                        <i className="fa fa-cart-arrow-down" /> {t.emekdasliq}
                      </a>
                      {/* <a href="#download" data-bs-toggle="tab">
                      <i className="fa fa-download" /> Download
                    </a>
                    <a href="#payment-method" data-bs-toggle="tab">
                      <i className="fa fa-credit-card" /> Payment Method
                    </a> */}
                      <a href="#address-edit" data-bs-toggle="tab">
                        <i className="fa fa-map-marker" /> {t.address}                      </a>
                      <a href="#account-info" data-bs-toggle="tab">
                        <i className="fa fa-user" /> {t.hesabmelumatlari}
                      </a>
                      <NavLink to="/" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt" /> {t.logout}
                      </NavLink>
                    </div>
                  </div>
                  {/* My Account Tab Menu End */}
                  {/* My Account Tab Content Start */}
                  <div className="col-lg-9 col-12">
                    <div className="tab-content" id="myaccountContent">
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade show active"
                        id="dashboad"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>{t.panel}</h3>
                          <div className="welcome mb-20">
                            <p>
                              {t.hello}{" "}
                              <strong>
                                {user_details.firstName} {user_details.lastName}{" "}
                                !
                              </strong>
                            </p>
                          </div>
                          <p className="mb-0">
                          {t.paneldesc}
                          </p>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="orders"
                        role="tabpanel"
                      >
                        {findActiveVacancies.length !== 0 && (
                          <>
                            <div className="activeBox">
                              <button
                                className="btnCompany"
                                onClick={() => {
                                  setActiveVacancies(true);
                                  setActiveJob(false);
                                }}
                              >
                                {t.activevac} {findActiveVacancies.length}{" "}
                                {t.activevac1}
                              </button>
                              <div className="pulsating-circle"></div>
                            </div>
                          </>
                        )}
                        <br />
                        <button
                          className="btnCompany activeCompanyBtn"
                          onClick={() => {
                            setActiveJob(true);
                            setActiveVacancies(false);
                          }}
                        >
                          {t.createjob}
                        </button>
                        {activeVacancies && activeJob == false && (
                          <div className="myaccount-content jobpostings mt-5 ">
                            <div className="allCvDetails">
                              <div className="row ">
                                {findActiveVacancies.map((item) => {
                                  return (
                                    <div className="col-lg-12 col-md-6 col-sm-12 col-12  my-3">
                                      <div className="row g-3">
                                        <>
                                          <NavLink
                                            // to={`/jobdetails/${
                                            //   slugify(
                                            //   `${item.id}-${item.ad}-${item.soyad}-${item.vezife}`
                                            // ).toLowerCase()}`}

                                            id="jobLink"
                                          >
                                            <div
                                              className="col-lg-3 col-md-2 col-sm-12 col-12"
                                              id="cvDetails"
                                              style={{
                                                borderTop: "2px solid #f3f3f3",
                                                borderLeft: "2px solid #f3f3f3",
                                                borderBottom:
                                                  "2px solid #f3f3f3",
                                                borderTopLeftRadius: "8px",
                                                borderBottomLeftRadius: "8px",
                                                background: "#fff",
                                              }}
                                            >
                                              <div className=" d-flex justify-content-center align-items-center">
                                                <img
                                                  src="https://www.shutterstock.com/image-vector/circle-line-simple-design-logo-600nw-2174926871.jpg"
                                                  alt=""
                                                  className="img-fluid"
                                                  style={{
                                                    objectFit: "contain",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              className="col-lg-9 col-md-10 col-sm-12 col-12"
                                              id="cvDetails"
                                              style={{
                                                borderTop: "2px solid #f3f3f3",
                                                borderRight:
                                                  "2px solid #f3f3f3",
                                                borderBottom:
                                                  "2px solid #f3f3f3",
                                                borderTopRightRadius: "8px",
                                                borderBottomRightRadius: "8px",
                                                background: "#fff",
                                              }}
                                            >
                                              <div className="d-flex justify-content-between">
                                                <div>
                                                  <h5 className="mt-3">
                                                    {item.vezife}
                                                    <br />
                                                    <span
                                                      style={{
                                                        opacity: "0.5",
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      {item.shirket_adi}
                                                    </span>
                                                  </h5>
                                                </div>
                                                <div className="d-flex">
                                                  <span className="heartIcon">
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                  </span>
                                                  <span className="heartIcon mx-2">
                                                    <i
                                                      className="fa-solid fa-trash"
                                                      style={{ color: "red" }}
                                                    ></i>
                                                  </span>
                                                </div>
                                              </div>
                                              <br />
                                              <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                <div className="d-flex align-items-center">
                                                  <i
                                                    class="fa-solid fa-money-bill"
                                                    style={{ color: "#4CAF50" }}
                                                  ></i>
                                                  <span className="ms-1">
                                                    {item.maas_min} ₼ -{" "}
                                                    {item.maas_max} ₼
                                                  </span>
                                                  <div>
                                                    <i
                                                      class="fa-solid fa-location-dot ms-4"
                                                      style={{
                                                        color: "#4CAF50",
                                                      }}
                                                    ></i>
                                                    <span className="ms-1">
                                                      {item.seher}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div>
                                                  <span>
                                                    {t.date}{" "}
                                                    {
                                                      item.created_at.split(
                                                        " "
                                                      )[0]
                                                    }
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </NavLink>
                                        </>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}

                        {activeJob && activeVacancies == false && (
                          <div className="myaccount-content jobpostings mt-5">
                            <h3>{t.iselaniyerlesdirmek}</h3>
                            <div className="myaccount-table table-responsive text-start">
                              <div className="container">
                                <CompanyInsert />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* <div
                      className="tab-pane fade"
                      id="download"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>Downloads</h3>
                        <div className="myaccount-table table-responsive text-center">
                          <table className="table table-bordered">
                            <thead className="thead-light">
                              <tr>
                                <th>Product</th>
                                <th>Date</th>
                                <th>Expire</th>
                                <th>Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Mostarizing Oil</td>
                                <td>Aug 22, 2022</td>
                                <td>Yes</td>
                                <td>
                                  <a href="#" className="ht-btn black-btn">
                                    Download File
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td>Katopeno Altuni</td>
                                <td>Sep 12, 2022</td>
                                <td>Never</td>
                                <td>
                                  <a href="#" className="ht-btn black-btn">
                                    Download File
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="payment-method"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>Payment Method</h3>
                        <p className="saved-message">
                          You Can't Saved Your Payment Method yet.
                        </p>
                      </div>
                    </div> */}
                      <div
                        className="tab-pane fade"
                        id="address-edit"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>{t.address}</h3>
                          <address>
                            <p>
                              <strong>
                                {" "}
                                {t.username} {user_details.firstName}{" "}
                                {user_details.lastName}
                              </strong>
                            </p>
                            <p>{t.mobil} : {user_details.mobile}</p>
                          </address>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade"
                        id="account-info"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>{t.hesabmelumatlari}</h3>
                          <div className="account-details-form">
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-lg-6 col-12 mb-30">
                                  <label htmlFor="">{t.name}</label>
                                  <input
                                    id="first-name"
                                    placeholder={t.name}
                                    name="firstName"
                                    type="text"
                                    value={value.firstName}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <label htmlFor="">{t.lastname}</label>
                                  <input
                                    id="last-name"
                                    placeholder={t.lastname}
                                    type="text"
                                    name="lastName"
                                    value={value.lastName}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-6 mb-30">
                                  <label htmlFor="">{t.email}</label>
                                  <input
                                    id="email"
                                    placeholder={t.email}
                                    type="email"
                                    name="email"
                                    value={value.email}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-6 mb-30">
                                  <label htmlFor="">{t.subscribe}</label>
                                  <input
                                    id="email"
                                    placeholder={t.subscribe}
                                    type="email"
                                    className="user_details_subs"
                                    disabled
                                    value={
                                      user_details.subscription == "0"
                                        ? "Kouç"
                                        : user_details.subscription == "1"
                                        ? "İş imkanları və inkişaf bazarı"
                                        : "Əməkdaşlıq"
                                    }
                                  />
                                </div>
                                <div className="col-12 mb-30">
                                  <h4>{t.sifreniyenile}</h4>
                                </div>
                                <div className="col-12 mb-30">
                                  <input
                                    id="current-pwd"
                                    placeholder={t.hazirki}
                                    type="text"
                                    name="oldPassword"
                                    onChange={handleChange}
                                  />
                                  <div
                                    className={`${
                                      !value.oldPassword && "d-none"
                                    }`}
                                  >
                                    <PasswordChecklist
                                      rules={[
                                        "minLength",
                                        "specialChar",
                                        "number",
                                        "capital",
                                        "lowercase",
                                        "oneSpecialChar",
                                        "noSpaces",
                                        "noUsername",
                                        "custom",
                                      ]}
                                      className="mb-5"
                                      minLength={8}
                                      value={value.oldPassword}
                                      onChange={(isValid) =>
                                        setIsPasswordValid(isValid)
                                      }
                                      messages={{
                                        minLength:
                                          "Şifrə ən az 8 simvoldan ibarət olmalıdır.",
                                        specialChar:
                                          "Şifrə xüsusi simvollar içerməlidir.",
                                        number: "Şifrə rəqəm içerməlidir.",
                                        capital:
                                          "Şifrə böyük hərf içerməlidir.",
                                        lowercase:
                                          "Şifrə kiçik hərf içerməlidir.",
                                        oneSpecialChar:
                                          "Şifrə ən az bir xüsusi simvol içerməlidir.",
                                        noSpaces: "Şifrə boşluq içerməməlidir.",
                                        noUsername:
                                          "Şifrə istifadəçi adını içerməməlidir.",
                                        custom:
                                          "Şifrə xüsusi bir şərtə cavab verməlidir.",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <input
                                    id="new-pwd"
                                    placeholder={t.yeni}
                                    type="text"
                                    disabled={!isPasswordValid}
                                    name="confirmPassword"
                                    value={value.confirmPassword}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <input
                                    id="confirm-pwd"
                                    placeholder={t.sifretestiq}
                                    type="text"
                                    name="newPassword"
                                    disabled={!isPasswordValid}
                                    onChange={handleChange}
                                  />
                                  {value.confirmPassword !==
                                  value.newPassword ? (
                                    <span className="text-danger">
                                      Şifrələr eyni deyil
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="col-12">
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-hover-secondary"
                                  >
                                    {t.yerlesdirin}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                    </div>
                  </div>
                  {/* My Account Tab Content End */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Admin;
